import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { CustomTabPanel, CustomTabs } from '@qler-view/shared_lib/src';
import FacitilityView from './facilityView';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import FacilityContactList from './FacilityContactList';
import CustomSnackbar from '@ui-components/Snackbar/CustomSnackbar';
import CustomIconButton from '@qler-view/shared_lib/src/shared/lib/ui-components/IconButton/CustomIconButton';
import CustomTypography from '@qler-view/shared_lib/src/shared/lib/ui-components/Typography/CustomTypography';
import { FACILITY_ROUTE_PATH } from '../../routers/routePaths';
import BackIcon from '@assets/images/BackIcon.svg';

const tabItems = [
  { label: 'Details', value: 0 },
  {
    label: `Contacts`,
    value: 1,
  },
];

const FacilityDetailsComponent: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { facilityId: paramFacilityId } = useParams<{
    facilityId?: string;
  }>();
  const facilityId = String(
    location.state?.facilityId ?? paramFacilityId ?? ''
  );
  const [activeTab, setActiveTab] = useState<number | string>(
    location?.state?.tab ?? 0
  );
  const [openToast, setOpenToast] = React.useState(false);
  const [message, setMessage] = React.useState('');
  useEffect(() => {
    if (location.state?.message) {
      setOpenToast(true);
      setMessage(location.state.message);
    }
  }, [location.state]);
  const handleTabChange = (
    _event: React.SyntheticEvent,
    newValue: number | string
  ) => {
    setActiveTab(newValue);
  };

  return (
    <Box>
      {openToast && (
        <CustomSnackbar
          id="toast-contact-list"
          successOrError={'success'}
          open={openToast}
          handleClose={() => setOpenToast(false)}
          toastrMessage={message}
        />
      )}
      <Box className="text-align-left display-flex pt-20 pb-16">
        <CustomIconButton
          id="back-button"
          icon={<BackIcon />}
          onClick={() => {
            navigate(FACILITY_ROUTE_PATH);
          }}
        ></CustomIconButton>

        <CustomTypography
          className="pl-8"
          variant="h4"
          id="view-facility-details"
        >
          Facilities
        </CustomTypography>
      </Box>
      <Box>
        <CustomTabs
          id="contacts-details-tab"
          tabs={tabItems}
          value={activeTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          allowScrollButtonsMobile={true}
          orientation="horizontal"
        />
      </Box>
      <CustomTabPanel value={activeTab} index={0}>
        <FacitilityView id={facilityId} />
      </CustomTabPanel>
      <CustomTabPanel value={activeTab} index={1}>
        <FacilityContactList facilityId={facilityId} />
      </CustomTabPanel>
    </Box>
  );
};

export default FacilityDetailsComponent;
